import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { CadsBadgeBitComponent } from '../../bits/cads-badge-bit/cads-badge-bit.component';
import { CadsLabeledAmountBitComponent } from '../../bits/cads-labeled-amount-bit/cads-labeled-amount-bit.component';

import { CadsAccountBalanceConfig } from './cads-account-balance.config';

/**
 * **Account balance** summary: {@link CadsLabeledAmountBitComponent} (**large** amount scale) with optional
 * {@link CadsBadgeBitComponent} stack top-right. No surface of its own—place inside {@link CadsCardViewComponent} or similar;
 * compose an {@link CadsInfoBadgeBitComponent} below when needed.
 */
@Component({
    selector: 'cads-account-balance',
    imports: [CadsBadgeBitComponent, CadsLabeledAmountBitComponent],
    templateUrl: './cads-account-balance.component.html',
    styleUrl: './cads-account-balance.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CadsAccountBalanceComponent {
  readonly config = input.required<CadsAccountBalanceConfig>();

  protected readonly _labeledAmountConfig = computed(() => {
    const c = this.config();
    return {
      label: c.label,
      amount: c.amount,
      compact: c.compact,
      size: 'large' as const,
    };
  });

  protected readonly _badges = computed(() => this.config().badges ?? []);
  protected readonly _hasBadges = computed(() => this._badges().length > 0);
}
